import { isFedRamp } from '@atlaskit/atlassian-context';
export var ARTIFACT_NAME = 'people-and-teams-configuration-service';
export var FD_ENVIRONMENT = 'prod';
export var FEDRAMP_PERIMETER = 'fedramp-moderate';
export var COMMERCIAL_PERIMETER = 'commercial';
export var FD_CLIENT_FETCH_PROPS = {
  name: ARTIFACT_NAME,
  dimensions: {
    environmentType: FD_ENVIRONMENT,
    perimeter: isFedRamp() ? FEDRAMP_PERIMETER : COMMERCIAL_PERIMETER
  }
};